import Images from "../Assets";

export const featureCatagoriesdData = [
  {
    id: 1,

    title: "LABTOP",
    background: Images.Img2,
  },
  { id: 2, title: "COMPUTER COMPONENTS", background: Images.Img3 },
  { id: 3, title: "DEVICES", background: Images.Img4 },
  { id: 4, title: "ACCESSORIES", background: Images.Img5 },
];
